const actions = {
  GET_ORGANIZATIONS_STATISTICS_REQUEST: "GET_ORGANIZATIONS_STATISTICS_REQUEST",
  GET_ORGANIZATIONS_STATISTICS_SUCCESS: "GET_ORGANIZATIONS_STATISTICS_SUCCESS",

  GET_ORGANIZATIONS_STATISTICS_BY_DATE_REQUEST:
    "GET_ORGANIZATIONS_STATISTICS_BY_DATE_REQUEST",
  GET_ORGANIZATIONS_STATISTICS_BY_DATE_SUCCESS:
    "GET_ORGANIZATIONS_STATISTICS_BY_DATE_SUCCESS",

  getAllOrganizationsStatistics: (token) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_ORGANIZATIONS_STATISTICS_REQUEST,
        token,
      });
    };
  },

  getAllOrganizationsByDatesStatistics: (startDate, endDate) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_ORGANIZATIONS_STATISTICS_BY_DATE_REQUEST,
        startDate,
        endDate,
      });
    };
  },
};

export default actions;
